import React from "react";

import { Trans } from "@lingui/macro";
import { truncate } from "lodash/fp";

import { SxProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import useTopicReportEntities from "@app/analytics/TopicReport/hooks/useTopicReportEntities";
import { generateSummaryTextFile } from "@app/analytics/TopicReport/utils";
import type { Topic } from "@app/analytics/types";
import useApps from "@app/common/hooks/useApps";
import ROUTES from "@app/common/routes";
import { withQueryParamsUrl } from "@app/common/utils";

import Link from "@rui/Link";

const StyledDownloadLink = styled(Link)(({ theme }) => ({
  fontWeight: 400,
  color: theme.palette.shades.neutral[800],
  padding: theme.spacing(1),
  display: "block",
  width: "100%",
}));

const getDownloadTitle = (title: string | null, name: string) =>
  title
    ? `${truncate({ length: 40, omission: "_" }, title)} ${name}`
    : `Topic ${name}`;

interface DownloadLinkProps {
  topic: Topic;
  onClose: () => void;
  linkText?: string;
  sx?: SxProps;
}
const DownloadLink = ({ topic, onClose, linkText, sx }: DownloadLinkProps) => {
  const { client } = useApps();
  const entities = useTopicReportEntities();

  const inZoomClient = client === "zoom";

  const summaryTxtFile = generateSummaryTextFile(topic, entities);

  return (
    <>
      <StyledDownloadLink
        sx={{ ...sx }}
        href={
          inZoomClient
            ? withQueryParamsUrl(ROUTES.GO.DOWNLOAD_SUMMARY, {
                topicId: topic.id,
              })
            : `data:text/plain,${summaryTxtFile}`
        }
        download={
          inZoomClient ? undefined : getDownloadTitle(topic.title, "summary")
        }
        onClick={onClose}
      >
        {linkText ?? (
          <>
            <Trans>Topic summary</Trans> (.txt)
          </>
        )}
      </StyledDownloadLink>
    </>
  );
};

export default DownloadLink;
